<template>
  <div class="flightDetailAssessmentMainContainer">
    <div
      class="flightDetailAssessmentHideContainer"
      v-show="!flightDetailAssessmentShow"
      @click="hideAssessment(true)"
    ></div>
    <div
      class="flightDetailAssessmentContainer"
      id="flightDetailAssessmentContainer"
      v-show="flightDetailAssessmentShow"
    >
      <div class="titleRow planAssessmentTitleRow">
        <img :src="planAssessmentImg" class="planAssessmentImg" />
        <label class="planAssessmentLabel">任务评估</label>
        <div class="hideImg" @click="hideAssessment(false)" />
      </div>
      <div class="separator"></div>
      <div class="titleRow">
        <img :src="gearImg" class="gearImg" />
        <label class="proposalLabel">建议参数</label>
      </div>
      <div class="proposalContainer">
        <div>
          <label class="title">时间：</label><label class="content">0.05分钟</label>
        </div>
        <div>
          <label class="title">里程：</label><label class="content">44.807900公里</label>
        </div>
        <div>
          <label class="title">平均速度：</label
          ><label class="content">53769.48公里/时</label>
        </div>
      </div>
      <div class="separator"></div>
      <div class="titleRow">
        <img :src="gearImg" class="gearImg" />
        <label class="proposalLabel">实际参数</label>
      </div>
      <div class="proposalContainer">
        <div>
          <label class="title">时间：</label><label class="content">0.05分钟</label>
        </div>
        <div>
          <label class="title">里程：</label><label class="content">44.807900公里</label>
        </div>
        <div>
          <label class="title">平均速度：</label
          ><label class="content">53769.48公里/时</label>
        </div>
      </div>
      <div class="separator"></div>
      <div class="titleRow">
        <img :src="assessmentImg" class="assessmentImg" />
        <label class="assessmentLabel">评估</label>
      </div>
      <div class="assessmentContainer">
        <div>
          <label class="title">平台载重效能</label><label class="content">0.55</label>
        </div>
        <div>
          <label class="title">投送速度效能</label><label class="content">0.56</label>
        </div>
        <div>
          <label class="title">飞行准确性效能</label><label class="content">0.4</label>
        </div>
        <div>
          <label class="title">单位重量单位距离时间效能</label
          ><label class="content">0.55</label>
        </div>
        <div>
          <label class="title">单位重量单位距离时间效能</label
          ><label class="content">0.56</label>
        </div>
        <div>
          <label class="title">综合效能指标</label><label class="content">61.4</label>
        </div>
      </div>
      <div class="separator"></div>
      <div class="titleRow">
        <img :src="airspaceImg" class="airspaceImg" />
        <label class="airspaceLabel">空域</label>
      </div>
      <div class="airspaceContainer">
        <el-checkbox v-model="forbiddenAirspace" @change="changeAirspace(1)"
          ><span class="forbiddenAirspace airspaceSpan"></span>
          <label class="clickLabel" @click="clickAirspace(1)">禁区</label> </el-checkbox
        ><el-checkbox v-model="restrictAirspace" @change="changeAirspace(2)"
          ><span class="restrictAirspace airspaceSpan"></span>
          <label class="clickLabel" @click="clickAirspace(2)">限制区</label> </el-checkbox
        ><el-checkbox v-model="earilAirspace" @change="changeAirspace(3)"
          ><span class="earilAirspace airspaceSpan"></span>
          <label class="clickLabel" @click="clickAirspace(3)"
            >临时飞行区</label
          > </el-checkbox
        ><el-checkbox
          v-model="cleanAirspace"
          class="cleanAirspaceRadio"
          @change="changeAirspace(4)"
          ><span class="cleanAirspace airspaceSpan"></span>
          <label class="clickLabel" @click="clickAirspace(4)">净空区</label> </el-checkbox
        ><el-checkbox v-model="dangerAirspace" @change="changeAirspace(5)"
          ><span class="dangerAirspace airspaceSpan"></span>
          <label class="clickLabel" @click="clickAirspace(5)">危险区</label>
        </el-checkbox>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import planAssessmentImg from "../../../assets/img/home/flightDetail/planAssessmentImg.png";
import gearImg from "../../../assets/img/home/flightDetail/gearImg.png";
import assessmentImg from "../../../assets/img/home/flightDetail/assessmentImg.png";
import airspaceImg from "../../../assets/img/home/flightDetail/airspaceImg.png";

export default {
  name: "flightDetailAssessment",
  data() {
    return {
      taskPlanObj: {},
      planAssessmentImg: planAssessmentImg,
      gearImg: gearImg,
      assessmentImg: assessmentImg,
      airspaceImg: airspaceImg,
      flightDetailAssessmentShow: true,
      forbiddenAirspace: false,
      restrictAirspace: false,
      earilAirspace: false,
      cleanAirspace: false,
      dangerAirspace: false,
    };
  },
  props: [],
  methods: {
    clickAirspace(type) {
      if (1 === type) {
        this.$data.forbiddenAirspace = !this.$data.forbiddenAirspace;
      } else if (2 === type) {
        this.$data.restrictAirspace = !this.$data.restrictAirspace;
      } else if (3 === type) {
        this.$data.earilAirspace = !this.$data.earilAirspace;
      } else if (4 === type) {
        this.$data.cleanAirspace = !this.$data.cleanAirspace;
      } else if (5 === type) {
        this.$data.dangerAirspace = !this.$data.dangerAirspace;
      }
      this.changeAirspace(type);
    },
    hideAssessment(flag) {
      this.$data.flightDetailAssessmentShow = flag;
    },
    changeAirspace(type) {
      let show = false;
      if (1 == type) {
        show = this.$data.forbiddenAirspace;
      } else if (2 == type) {
        show = this.$data.restrictAirspace;
      } else if (3 == type) {
        show = this.$data.earilAirspace;
      } else if (4 == type) {
        show = this.$data.cleanAirspace;
      } else if (5 == type) {
        show = this.$data.dangerAirspace;
      }
      this.$emit("showAirspace", { type, show });
    },
  },
  mounted() {},
  watch: {
    radio0(nval, oval) {
      debugger;
    },
  },
  computed: {},
  components: {},
  beforeDestroy() {},
};
</script>

<style scoped>
@import "../../../assets/css/home/flightDetail/flightDetailAssessment.css";
</style>
<style>
.flightDetailAssessmentMainContainer
  .airspaceContainer
  .el-checkbox.is-checked
  .el-checkbox__input {
  background: url(../../../assets/img/home/flightDetail/checkedImg.png);
  background-repeat: no-repeat;
}

.flightDetailAssessmentMainContainer
  .airspaceContainer
  .el-checkbox.is-checked
  .el-checkbox__inner {
  border: none;
}
.flightDetailAssessmentMainContainer
  .airspaceContainer
  .el-checkbox.is-checked
  .el-checkbox__inner::after {
  content: none;
}
.flightDetailAssessmentMainContainer .airspaceContainer .el-checkbox .el-checkbox__inner {
  width: 14px;
  height: 14px;
  border: 2px solid #ffffff;
  border-radius: 3px;
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/home/flightDetail/flightDetailAssessment.vue